import api from "./api";
import { AppResponse } from "../models/common/app-response";
import { DesktopNotificationDto } from "../models/notifications/desktopNotificationDto";

class NotificationsService {
  async getUnread() {
    const response = await api.get<AppResponse<DesktopNotificationDto[]>>("/api/v1/desktop-notifications/unread");
    return response.data.data ?? [];
  }

  async getCount() {
    const response = await api.get<AppResponse<number>>("/api/v1/desktop-notifications/count");
    return response.data.data ?? 0;
  }

  async markAsRead(id: number) {
    const response = await api.post<AppResponse<number>>(`/api/v1/desktop-notifications/${id}/read`);
    return response.data.data;
  }
}

export const notificationsService = new NotificationsService();

